import React from 'react';
import { Typography } from '@slope/uikit';

export interface HomeHeaderProps {
  title?: string;
  subtitle?: string;
}

export const HomeHeader: React.FC<HomeHeaderProps> = ({
  title = 'Elige un club de golf',
  subtitle = 'Explora experiencias de campo de golf 3D inmersivas',
}) => {
  return (
    <>
      <Typography fontSize="48px" fontWeight="bold" mb="1rem" color="#2c3e50" textAlign="center">
        {title}
      </Typography>
      <Typography fontSize="18px" mb="2rem" color="#7f8c8d" textAlign="center">
        {subtitle}
      </Typography>
    </>
  );
};
